import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast, BASE_URL } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DepartmentWiseOpdReportPdf from '../../../../Print/options/Hospital/HMS/DepartmentWiseReportPdf';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';


export const DepartmentWiseOpdReport = () => {
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  
  const [openPrint, setOpenPrint] = useState(false);

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown([{ _id: 'all', department: 'All' }, ...data]);
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
  }, [getDepartmentDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/outpatient-management/department-wise-opd?refId=${JSON.stringify({ department: watch('department'), from_date: watch('from_date'), to_date: watch('to_date') })}`)
    //  console.log("response data", response);
    if (response.data.success) {
    const filteredData = response?.data?.data || [];
      if (filteredData.length > 0) {
        console.log("If Condition Data", filteredData);

        const fileName = `Department_Wise_Opd_Report_${watch('from_date')}_to_${watch('to_date')}`;
        
        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Reg. Date': formatDate(item?.opd?.date),
          'MR No.': "",
          'Patient ID': item?.opd?.uhid,
          'Patient Name': (`${item?.opd?.name_suffix} ${item?.opd?.first_name} ${item?.opd?.last_name}`),
          'Age': (new Date().getFullYear() - new Date(item.opd.dob).getFullYear()),
          'Gender': item?.opd?.gender,
          'Guardian Name': item?.opd?.guardian_name,
          'Address': item?.opd?.address?.address,
          'Department': item?.opd?.department?.department,
          'New/Revisit Patient': item?.opd?.visit_no,
          
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      }else{
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Department Wise OPD
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('department')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ department: watch('department'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    ) } >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('department')}
                  onClick={handleExcelReport}
                >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="department"
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <DepartmentWiseOpdReportPdf />
      </Dialog>
    </>
  );
};
